"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var libphonenumber_js_1 = require("libphonenumber-js");
/**
 * Функция которая получает номер, и возврашает если он не равен '+7'
 * @param phone - номер телефона
 */
function trimPhone(phone) {
    if (phone === '+7') {
        return null;
    }
    else {
        return phone;
    }
}
exports.trimPhone = trimPhone;
/**
 * Переформатирует номер телефона, в вид для отображения пользователю,
 * Если номер телефона начинается с 8 то перделывает на +7
 * @param phoneExists - номер телефона
 */
function reFormatPhone(phoneExists) {
    var newPhone = phoneExists;
    if (!phoneExists) {
        return null;
    }
    if (phoneExists.substring(0, 1) === '8') {
        newPhone = '+7' + phoneExists.substring(1);
    }
    return libphonenumber_js_1.formatIncompletePhoneNumber(newPhone, 'RU');
}
exports.reFormatPhone = reFormatPhone;
/**
 * Метод изменения номера телефона клиента
 * @param phoneExists - номер телефона
 * @param phoneNew - новый номер телефона
 */
function onChangePhone(phoneExists, phoneNew) {
    if ((!phoneExists || phoneExists.substring(0, 2) === '+7') &&
        phoneNew.substr(0, 2) === '+7' &&
        phoneNew.length <= 16) {
        return libphonenumber_js_1.formatIncompletePhoneNumber(phoneNew, 'RU');
    }
    else {
        return phoneExists;
    }
}
exports.onChangePhone = onChangePhone;
/**
 * Переформатирует телефон(убирает, скобочки, пробелы, дефисы) в формат для сохранения в БД(+7**********)
 * @param phoneNumber - номер телефона
 */
function trimPhoneNumber(phoneNumber) {
    return phoneNumber.replace('(', '').replace(')', '').replace(/ /g, '').replace('-', '');
}
exports.trimPhoneNumber = trimPhoneNumber;
/**
 * Переформатирует номер телефона из 8 и без префикса в +7
 * @param phoneNumber - номер телефона(формат для поиска в фильтрах без пробелов и других спец символов)
 */
function reformatPhoneForFilter(phoneNumber) {
    if (!phoneNumber) {
        return null;
    }
    var newPhoneNumber = phoneNumber;
    if (newPhoneNumber.length === 10 && newPhoneNumber.substring(0, 2) !== '+7') {
        newPhoneNumber = '+7' + newPhoneNumber;
    }
    else if (newPhoneNumber.length === 11 &&
        (newPhoneNumber.substring(0, 1) === '8' || newPhoneNumber.substring(0, 1) === '7')) {
        newPhoneNumber = '+7' + newPhoneNumber.substring(1);
    }
    return newPhoneNumber;
}
exports.reformatPhoneForFilter = reformatPhoneForFilter;
function encryptPhoneNumber(phoneNumber) {
    var str = '';
    var array = phoneNumber.split('');
    var newArray = [];
    for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
        var item = array_1[_i];
        var number = parseInt(item, 10);
        newArray.push((number + 6) % 10);
    }
    for (var _a = 0, newArray_1 = newArray; _a < newArray_1.length; _a++) {
        var item = newArray_1[_a];
        str += (item * 13).toString() + 'a';
    }
    str = str.substr(0, str.length - 1);
    return str;
}
exports.encryptPhoneNumber = encryptPhoneNumber;
//# sourceMappingURL=index.js.map